import { render, staticRenderFns } from "./DetailChat.vue?vue&type=template&id=7f2d3aa1&scoped=true"
import script from "./DetailChat.vue?vue&type=script&lang=js"
export * from "./DetailChat.vue?vue&type=script&lang=js"
import style0 from "./DetailChat.vue?vue&type=style&index=0&id=7f2d3aa1&prod&lang=css&scoped=true"
import style1 from "./DetailChat.vue?vue&type=style&index=1&id=7f2d3aa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2d3aa1",
  null
  
)

export default component.exports